/** API route map: URLS.Controller.Common */
export const Common = {
      Name: 'Common/',
      GetCityStateList: 'get-zip-city-state-list',
      GetCountryList: 'get-country-list',
      GetCarrierList: 'get-carrier-list',
      GetPlantypeList: 'get-plan-type-list',
      GetIndustryList: 'get-industry-list-by-name',
      GetLanguageList: 'get-language-list',
      GetEthnicityList: 'get-ethnicity-list',
      GetDBUser: 'get-db-users',
      GetStateList: 'get-state-list',
      GetRelationshipList: 'get-relationship-list',
      GetSkillList: 'get-skill-list',
      GetTaxIdentifier: 'get-tax-identifiers',
      GetTaxFilingStatus: 'get-tax-filling-status',
      SaveStateTax: 'save-state-tax',
      GetStateTax: 'get-employee-state-tax',
      alterTableColumnByUser: 'alter-table-column-by-user',
      getAlterTableColumnByUser: 'get-alter-table-column-by-user',
      GetDecryptSsn: 'get-decrypt-SNN',
};
